import CONSTANTS from "../../../const/constants";
import PlanStatus from "../../../const/planStatus";

export const getSucriptionAlertMessage = ({
  daysToExpire,
  paymentIntents,
  paymentMethod,
  company,
}) => {
  try {
    console.log('company', company);
    const companyId = company?.id;
    const status = company?.status;

    if (status !== PlanStatus.AWAITING_SUSCRIPTION_PAYMENT && status !== PlanStatus.AWAITING_BILLABLE_EXTRA_MESSAGES_PAYMENT) return null;

    if (CONSTANTS.COMPANIES_CUSTOM_PAYMENTS?.includes(companyId)) return null;
  
    if (paymentIntents === 1) {
      if (paymentMethod === "CARD") {
        return {
          message: `Tuvimos problemas al cobrar la suscripción, intentaremos cobrar de nuevo en unos días`,
          type: "warning",
          buttonMessage: "Pagar ahora",
        };
      }
      if (paymentMethod === "TRANSFER") {
        return {
          message:
            "No se ha recibido el pago de la transferencia, por favor verifica que se haya realizado correctamente",
          type: "warning",
          buttonMessage: "Pagar ahora",
        };
      }
    }
    if (paymentIntents === 2) {
      if (paymentMethod === "CARD") {
        return {
          message: `Tuvimos problemas al cobrar tu suscripción, por favor completa tu pago cuánto antes`,
          type: "warning",
          buttonMessage: "Pagar ahora",
        };
      }
      if (paymentMethod === "TRANSFER") {
        return {
          message:
            "No se ha recibido el pago de la transferencia, por favor verifica que se haya realizado correctamente",
          type: "warning",
          buttonMessage: "Pagar ahora",
        };
      }
    }
    if (paymentIntents === 3) {
      if (paymentMethod === "CARD") {
        return {
          message: `Tuvimos problemas al cobrar la suscripción, evita que tu cuenta sea pausada`,
          type: "error",
          buttonMessage: "Pagar ahora",
        };
      }
      if (paymentMethod === "TRANSFER") {
        return {
          message: `Tuvimos problemas al cobrar la suscripción, evita que tu cuenta sea pausada`,
          type: "error",
          buttonMessage: "Pagar ahora",
        };
      }
    }
    if (paymentIntents > 3) {
      return {
        message: `Tu cuenta ha sido pausada por falta de pago, por favor realiza el pago para reactivarla`,
        type: "error",
        buttonMessage: "Pagar ahora",
      };
    }
    if (daysToExpire <= 1 && daysToExpire > 0) {
      return {
        message:
          "El día de mañana se hará el cobro de tu plan, por favor verifica que tengas saldo suficiente en tu tarjeta.",
        type: "warning",
        buttonMessage: "Ver cuenta",
      };
    }
  
    return null;
  } catch (error) {
    console.log('error', error);
    return null;
  }
};
